import { RoundedBox } from '@react-three/drei'

type Vetor = [number, number, number]

/**
 * Peça arredondada com material PBR configurável — mesmo padrão de
 * `Cabine3D.tsx` (`Peca`), compartilhado aqui para as figuras da mesa não
 * duplicarem o wrapper do `RoundedBox`.
 */
export function PecaDetalhe3D({
  posicao,
  tamanho,
  cor,
  metal = 0,
  rugosidade = 0.5,
  raio = 0.03,
  rotacao,
  realce,
}: {
  posicao: Vetor
  tamanho: Vetor
  cor: string
  metal?: number
  rugosidade?: number
  raio?: number
  rotacao?: Vetor
  realce?: { emissive: string; emissiveIntensity: number }
}) {
  return (
    <RoundedBox
      position={posicao}
      args={tamanho}
      radius={Math.min(raio, ...tamanho.map((lado) => lado * 0.45))}
      smoothness={2}
      rotation={rotacao}
      castShadow
      receiveShadow
    >
      <meshStandardMaterial
        color={cor}
        metalness={metal}
        roughness={rugosidade}
        {...realce}
      />
    </RoundedBox>
  )
}
